import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Btn, StatusPanel } from '../components/design-system';

const NewsletterUnsubscribe: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid unsubscribe link.');
      return;
    }
    const run = async () => {
      try {
        const res = await fetch(`/api/newsletter/unsubscribe/${token}`, { method: 'POST' });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'Failed to unsubscribe');
        setStatus('success');
        setMessage(
          'You have been unsubscribed from our newsletter. Changed your mind? You can resubscribe anytime from the homepage.'
        );
      } catch (err) {
        setStatus('error');
        setMessage(err instanceof Error ? err.message : 'Failed to unsubscribe');
      }
    };
    run();
  }, [token]);

  return (
    <StatusPanel title="newsletter · unsubscribe" status={status} message={message}>
      {status !== 'loading' && (
        <div style={{ marginTop: 20 }}>
          <Btn variant="primary" to="/">
            back to home
          </Btn>
        </div>
      )}
    </StatusPanel>
  );
};

export default NewsletterUnsubscribe;
